import React from 'react';
import { Header, Segment, List, Label } from 'semantic-ui-react';
import Highlighter from 'react-highlight-words';
import api from '../../../api';

const subdominios = {
  linguistica: 'Lingüística Aplicada',
  literatura: 'Literatura',
  bibliotecon: 'Biblioteconomía',
  medicina: 'Ciencias de la Salud',
  biologia: 'Biología',
  sociologia: 'Sociología',
  educacion: 'Educación',
  economia: 'Economía y empresa',
  ingenieria: 'Ingeniería',
  informatica: 'Informática y electrónica',
  cc_tierra: 'Ciencias de la Tierra',
  fisica_quimica: 'Física y química',
  arte: 'Arte'
};

const labelStyle = {
  cursor: 'default',
  marginBottom: '4px'
};

class QualitativeDetailsCollation extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      renderFuncionesDiscursivas: false,
      showEmptyResult: false,
      Ejemplos: [],
      Colocacion: [],
      totales: []
    };
  }

  componentDidMount = () => {
    const { lema, categoria, id, corpus, clasificacion, sintagma } = this.props;
    api.colocaciones
      .getOneCategory(lema, categoria, id, sintagma)
      .then(Colocacion => this.setState({ Colocacion }));

    if (!categoria) return;
    this.setState({ loading: true });
    const cadena = clasificacion.replace(' + ',' ');
    api.colocaciones.getDatosCuantitativos(lema,sintagma,cadena).then(resultadosDC => {
    //api.colocaciones.getDatosCuantitativos(lema,categoria).then(resultadosDC => {
      if (typeof resultadosDC !== 'undefined') {
        if (
          resultadosDC.length > 0
        ) {
          this.setState({            
            totales: resultadosDC
          });
        }
      }
       this.setState({ loading: false });
    });    
  };
 componentDidUpdate(prevProps) {
  if (this.props.lema !== prevProps.lema) {
    this.state.Colocacion.map(glosa => (api.colocaciones
      .getExampleById(glosa.id)
      .then(Ejemplos => {this.setState({ Ejemplos })})
    ));
  }
}

  
componentWillReceiveProps(nextProps){
    this.state.Colocacion.map(glosa => (api.colocaciones
        .getExampleById(glosa.id)
        .then(Ejemplos => {this.setState({ Ejemplos })})
        ));
  }
  render() {
    const { lema } = this.props;
    var tags = [];

    this.state.totales.map(dato => {
      if(dato.bibliotecon > 0) tags.push(subdominios.bibliotecon);
      if(dato.biologia > 0) tags.push(subdominios.biologia);
      if(dato.cc_tierra > 0) tags.push(subdominios.cc_tierra);
      if(dato.economia > 0) tags.push(subdominios.economia);
      if(dato.educacion > 0) tags.push(subdominios.educacion);
      if(dato.fisica_quimica > 0) tags.push(subdominios.fisica_quimica);
      if(dato.informatica > 0) tags.push(subdominios.informatica);
      if(dato.ingenieria > 0) tags.push(subdominios.ingenieria);
      if(dato.linguistica > 0) tags.push(subdominios.linguistica);
      if(dato.literatura > 0) tags.push(subdominios.literatura);
      if(dato.medicina > 0) tags.push(subdominios.medicina);
      if(dato.sociologia > 0) tags.push(subdominios.sociologia);
      if(dato.arte > 0) tags.push(subdominios.arte);
    });

    return (      
      <div>
        <Header as="h3" block attached="top" color="blue">
          Detalles de la Colocación
        </Header>
        <Segment attached>
          <h3>Glosa</h3>
          <List divided selection>
            {this.state.Colocacion.map(glosa => (
              <p key={glosa.id}>
                {glosa.glosa}
              </p>
            ))}
          </List>

          <h3>Dominio</h3>
          {tags.length === 0 && <p>Ningún dominio asociado</p>}
          {tags.map((tag, key) => (   
            <Label basic style={labelStyle} key={key}>
              {tag}
            </Label>
          ))}
          
          {this.state.Ejemplos.length > 0 && <h3>Ejemplos</h3>}
          {this.state.Ejemplos.map(ejemplo => (
            <Segment key={ejemplo.id} color="blue">
              <Highlighter
                highlightClassName="resaltado-texto"
                highlightStyle={{ backgroundColor: 'white' }}
                searchWords={[lema]}
                autoEscape={true}
                textToHighlight={ejemplo.ejemplo}                 
              />
            </Segment>
          ))}
        </Segment>
      </div>
    );
  }
}

export default QualitativeDetailsCollation;
